export default __webpack_public_path__ + "static/media/bsn-color.6a90dde3.svg";